export default __webpack_public_path__ + "static/media/companyLogo6.a4e2152d.png";